// extracted by mini-css-extract-plugin
export var card = "_l7-5";
export var cardSelected = "_l7-4";
export var image = "_l7-3";
export var modal = "_l7-0";
export var modalContent = "_l7-1";
export var table = "_l7-2";